<template>
  <div class="container login-page mt-3">
    <div class="row">
      <div
        class="col-xs-12 col-sm-6 col-md-4 offset-sm-3 offset-md-4 text-center">
        <p v-if="errorMessage" class="mb-3">{{ errorMessage }}</p>
        <div class="form-group">
          <input
            id="email"
            v-model="userEmail"
            type="email"
            name="email"
            class="form-control"
            placeholder="Email">
        </div>
        <div class="form-group">
          <input
            id="pass"
            v-model="userPass"
            type="password"
            name="pass"
            class="form-control"
            placeholder="Password">
        </div>
        <button class="btn btn-primary login-btn" @click="login()">
          Login
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import { mapMutations, } from 'vuex';

export default {
	name: 'Login',
	data: () => {
		return {
			userEmail: '',
			userPass: '',
			errorMessage: '',
		};
	},
	methods: {
      ...mapMutations(['setCurrentUser',]),
		login() {
			// const $this = this;
			firebase
				.auth()
				.signInWithEmailAndPassword(this.userEmail, this.userPass)
				.then((user) => {
					this.setCurrentUser(user);
					this.$router.push('/');
				})
				.catch((error) => {
					this.errorMessage = error.message;
				});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue